type ExperimentContentFlags = { ignore_default_content?: boolean }

function isPlainObject(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value)
}

function pickDefined(source: Record<string, unknown>): Record<string, unknown> {
  return Object.fromEntries(Object.entries(source).filter(([, value]) => value !== undefined))
}

export function mergeExperimentContent<T extends object>(defaultContent: T, payload: T & ExperimentContentFlags): T {
  const { ignore_default_content: ignoreDefaultContent, ...content } = payload

  if (ignoreDefaultContent) return content as T

  const merged: Record<string, unknown> = {}

  for (const key of Object.keys(defaultContent)) {
    const defaultValue = (defaultContent as Record<string, unknown>)[key]
    const value = (content as Record<string, unknown>)[key]

    if (value === undefined) merged[key] = defaultValue
    else if (isPlainObject(defaultValue) && isPlainObject(value))
      merged[key] = { ...defaultValue, ...pickDefined(value) }
    else merged[key] = value
  }

  return merged as T
}
